import React, { FC } from 'react';
import { IntlProvider } from 'react-intl';
import { translations } from '../utils/i18n';

const LanguageProvider: FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <IntlProvider locale={'en'} messages={translations['en']}>
      {children}
    </IntlProvider>
  );
};

export { LanguageProvider };
